const Programs = () => {
    return(
        <h1>Programs</h1>
    );
}

export default Programs;